import React, { HTMLAttributes } from 'react'

export const MerifyMMarkSvg = ({ className, ...props }: HTMLAttributes<HTMLOrSVGElement>) => {
	return (
		<svg
			width={399}
			height={399}
			viewBox='0 0 399 399'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`merify-m-mark${className ? ` ${className}` : ''}`}
			{...props}
		>
			<path
				d='M199.5 399C309.681 399 399 309.681 399 199.5 399 89.32 309.681 0 199.5 0 89.32 0 0 89.32 0 199.5 0 309.681 89.32 399 199.5 399z'
				fill='#FF4856'
			/>
			<path
				d='M150.689 89.443c-6.184 0-16.493 3.125-28.862 3.125-22.343 0-23.54-4.788-23.54-4.788 0-1.662 5.785-5.785 8.245-5.785a8.847 8.847 0 011.862 0 36.777 36.777 0 0010.108 1.463c28.861 0 52.004-17.956 72.42-17.956 17.356 0 23.541 7.648 23.541 18.554 0 23.74-29.726 62.975-39.036 73.15a.796.796 0 00.799.798c4.921 0 72.218-77.14 89.508-85.386a20.877 20.877 0 018.711-2.26 12.041 12.041 0 0110.108 4.72 45.154 45.154 0 0112.569 26.601 21.016 21.016 0 01-3.524 11.371c-7.448 11.305-30.724 45.153-30.724 49.742 0 0 0 .399.399.399 2.461 0 9.311-7.448 9.311-7.448 1.596-2.261 47.014-39.9 63.506-39.9a9.84 9.84 0 018.712 10.308 7.962 7.962 0 01-2.062 5.785c-11.97 14.231-52.867 88.91-52.867 124.022a16.493 16.493 0 0016.292 16.493 39.905 39.905 0 0033.25-28.263s1.664-2.261 2.861-2.261c1.197 0 2.926 3.923 2.926 5.785 0 17.756-48.944 85.785-102.543 85.785-18.154 0-30.99-10.107-30.99-31.986 0-15.228 6.65-36.309 21.28-63.707 0 0 20.616-39.235 21.214-43.557 0-.798-.4-1.464-.998-1.464a7.245 7.245 0 00-3.922 2.062c-1.064 1.663-34.248 43.956-44.955 52.003a33.253 33.253 0 01-21.281 7.249c-17.755 0-45.418-6.651-45.418-15.495a11.034 11.034 0 012.326-6.184c6.185-8.446 31.323-42.095 31.323-42.095 0-2.261-.001-3.924-.799-3.924s-.864.001-1.462.865c-2.66 2.66-49.077 51.737-57.789 56.725a53.604 53.604 0 01-23.74 6.65c-18.953 0-44.355-21.28-44.355-37.573 0-1.396 1.063-3.923 7.846-7.381 39.9-21.48 105.668-87.315 105.668-111.255-.333-3.724-2.393-4.987-5.918-4.987z'
				fill='#110BE0'
			/>
		</svg>
	)
}
